<template>
  <v-radio-group
    v-model="selected"
    class="mb-n6"
    row
    label="Тип продукту: "
  >
    <v-radio
      v-for="(productType, index) in productTypes.length"
      :key="index"
      :label="productTypes[productType-1].title"
      :value="productTypes[productType-1].value"
    />
  </v-radio-group>
</template>

<script>
import { productTypes } from "@/helpers";

export default {
  props: {
    value: {
      type: Number,
    },
    isNew: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    selected: null,
  }),
  computed: {
    productTypes() {
      return [
        {
          value: productTypes.SOFTWARE.value,
          title: productTypes.SOFTWARE.title,
        },
        {
          value: productTypes.LICENSE.value,
          title: productTypes.LICENSE.title,
        },
        {
          value: productTypes.OTHER.value,
          title: productTypes.OTHER.title,
        }];
    },
  },
  watch: {
    selected(val) {
      this.$emit("input", val);
    },
    value: {
      handler(val) {
        if (this.isNew && val === null) {
          this.selected = 2;
        }
        this.selected = val;
      },
      immediate: true,
    },
  },
};
</script>